'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebHaptics } from 'web-haptics/react';
import type { ViewLayout } from '@/hooks/useViewPreferences';
interface ViewLayoutToggleProps {
  layout: ViewLayout;
  onLayoutChange: (layout: ViewLayout) => void;
}
export function ViewLayoutToggle(t0) {
  const $ = _c(17);
  const {
    layout,
    onLayoutChange
  } = t0;
  const haptic = useWebHaptics();
  let t1;
  if ($[0] !== haptic || $[1] !== onLayoutChange) {
    t1 = () => {
      haptic.trigger("selection");
      onLayoutChange("grid");
    };
    $[0] = haptic;
    $[1] = onLayoutChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `p-2 transition-opacity ${layout === "grid" ? "opacity-100" : "opacity-40 hover:opacity-70"}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" strokeWidth={1.5} /><rect x="14" y="3" width="7" height="7" strokeWidth={1.5} /><rect x="3" y="14" width="7" height="7" strokeWidth={1.5} /><rect x="14" y="14" width="7" height="7" strokeWidth={1.5} /></svg>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2) {
    t4 = <button type="button" onClick={t1} className={t2} aria-label="Grid view">{t3}</button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== haptic || $[8] !== onLayoutChange) {
    t5 = () => {
      haptic.trigger("selection");
      onLayoutChange("carousel");
    };
    $[7] = haptic;
    $[8] = onLayoutChange;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `p-2 transition-opacity ${layout === "carousel" ? "opacity-100" : "opacity-40 hover:opacity-70"}`;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="8" width="4" height="8" strokeWidth={1.5} /><rect x="8" y="8" width="4" height="8" strokeWidth={1.5} /><rect x="14" y="8" width="4" height="8" strokeWidth={1.5} /><rect x="20" y="8" width="4" height="8" strokeWidth={1.5} /></svg>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6) {
    t8 = <button type="button" onClick={t5} className={t6} aria-label="Carousel view">{t7}</button>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t8) {
    t9 = <div className="flex items-center">{t4}{t8}</div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}